// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-ohif {\r\n  font-size: 1em;\r\n  color: #ffffff;\r\n}\r\n\r\n.label-example {\r\n  background-color: var(--ui-gray-darker);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
